import React, { useEffect, useState } from "react";
import LeftMenu from "../../../components/layout/leftMenu";
import Header from "../../../components/layout/header";
import ProductList2 from "./ProductList2";
import { backendApi } from "../../../api/apiService";
import { useSelector } from "../../../components/hooks/hooks";
import OpeningList from "./OpeningList2"
import StatusChart2 from "./StatusChart2";
import LoaderImage from "../../../images/spinner.gif";

export default function AnalyticsDashboardTwo() {
    const [menuClick, setMenuClick] = useState(false);
    const { userDetails, userData, userId, siteId } = useSelector(
        (state) => state.login
    );
    const [Data, setData] = useState([])
    const [CandidateList, setCandidateList] = useState([])
    const [OpeningLists, setOpeningList] = useState([]);
    const [shortList, setshortList] = useState([]);
    const [jobopenings, setjobopenings] = useState([])
    const [openingStatus, setopeningStatus] = useState([])
    const [Loader, setLoader] = useState(false)


    const toggleMenu = () => {
        setMenuClick(!menuClick);
    };
    const closeMenu = () => {
        setMenuClick(false);
    };
    useEffect(() => {
        manageranAlyticsDashboard()
    }, [])
    const manageranAlyticsDashboard = () => {
        const req = {
            functionName: "userAnalyticsDashboard",
            site_id: siteId,
            sec_user_id: userId,
            //sec_user_id: siteId,
        };
        backendApi(req)
            .then((response) => {
                if (response.success === "1") {
                    console.log(response, "userAnalyticsDashboard");
                    setLoader(true)
                    setData(response.dataSet)
                    setCandidateList(response.candidateList);
                    setOpeningList(response.openingList);
                    setshortList(response.shortList);
                    setjobopenings(response.jobopenings);
                    setopeningStatus(response.openingStatus);
                } else {
                    console.error("Backend responded with an error", response);
                }
            })
            .catch((error) => {
                console.error("An error occurred during the API call:", error);
            });
    };

    return (

        <>
            <div className="main-wrapper analytics-dashboard">
                <div className="top-color"></div>
                <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
                <div className="content-wrapper">
                    <Header
                        Header="Analytics Dashboard"
                        toggleMenu={toggleMenu}
                        menuClick={menuClick}
                    />
                    <div className="main-container">
                        {Loader ?
                            <div className="analytics-report">

                                <div className="analytics-slider">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6 mb-3 mb-lg-0">

                                                    {jobopenings.map((job, index) => (
                                                        <React.Fragment key={index}>
                                                            <h3 className="dash-sub01"> {job.openings} <span className="dash-sub-sub">(Opening)</span></h3>
                                                            <p>{job.opening_summary}</p>
                                                        </React.Fragment>
                                                    ))}

                                                </div>

                                                <div className="col-lg-4 col-md-6 mb-3 mb-lg-0">
                                                    {shortList.map((job, index) => {
                                                        let progressClass;
                                                        let progressPercentage;
                                                        if (job.status_name === "Recruit") {
                                                            progressClass = ' bg-success';
                                                            progressPercentage = (job.cnt / jobopenings[0].openings) * 100;
                                                        } else if (job.status_name === "Reject") {
                                                            progressClass = 'bg-danger';
                                                            progressPercentage = (job.cnt / jobopenings[0].openings) * 100;
                                                        } else if (job.status_name === "On Hold") {
                                                            progressClass = 'bg-warning';
                                                            progressPercentage = (job.cnt / (jobopenings[0].openings)) * 100;
                                                        }
                                                        return (
                                                            <div key={index} className='analytics-progress'>
                                                                <label>{job.status_name}</label>
                                                                <div className="progress">
                                                                    <div className={`progress-bar ${progressClass}`} style={{ width: `${progressPercentage}%` }}>
                                                                        {job.cnt}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>

                                                <div className="col-lg-4 col-md-12">
                                                    <h4 className="dash-sub-head">Job Opening</h4>
                                                    <StatusChart2 Data={openingStatus} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <ProductList2 Data={CandidateList} />
                                                </div>
                                                <div className="col-md-6">
                                                    <OpeningList Data={OpeningLists} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : <div className="loader-div">
                                <img src={LoaderImage} alt="Loader" className="loader" />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>

    )
}